import { render, staticRenderFns } from "./EstruturaWidgetTabela.vue?vue&type=template&id=8dd5339a"
import script from "./EstruturaWidgetTabela.vue?vue&type=script&lang=js"
export * from "./EstruturaWidgetTabela.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports